import React from 'react';
import { AlertCircle, X } from 'lucide-react';

interface CropErrorProps {
  error: string | null;
  onDismiss: () => void;
}

export const CropError: React.FC<CropErrorProps> = ({ error, onDismiss }) => {
  if (!error) {
    return null;
  }

  return (
    <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 z-10 max-w-md">
      <AlertCircle className="h-5 w-5 flex-shrink-0" />
      <span className="text-sm font-medium">{error}</span>
      <button
        onClick={onDismiss}
        className="ml-2 hover:bg-red-700 rounded p-1 transition-colors flex-shrink-0"
        aria-label="Dismiss error"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
